import { render, staticRenderFns } from "./AttachPeopleToCompany.vue?vue&type=template&id=fb0ff710&scoped=true&"
import script from "./AttachPeopleToCompany.vue?vue&type=script&lang=js&"
export * from "./AttachPeopleToCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0ff710",
  null
  
)

export default component.exports